import { REACT_APP_DEV_CDN } from "../../constants/enviroments";

export const getImageBaseUrl = REACT_APP_DEV_CDN;
